import './form';
import './components/texarea-count';

(function (w) {
    // Définit l'objet Completude
    w.Completude = Object.assign({}, w.Completude, {
        demandeProfesseur: {
            
            $form:null,            
            steps:null,
            gtmPage:'DemandeProf',
            
            init: function () {
                                
                Completude.demandeProfesseur.$form = Completude.SetFormValidation($('#form-demande-prof'));                                           

                // Active la gestion des étapes (library Steps.js)
                this.steps = new Steps({
                    steps: '[data-step-index]',
                    progress : '.progress-step',
                    container: document.querySelector('#section-form-demande-prof'),
                    backNavigator : true
                });
                               
                // Sur changement de la classe on charge les matières
                $("#field-class").on('selectric-change',function(ev,el,selectric) {  
                    if (el.value!='') {
                        Completude.demandeProfesseur.updateMatieres(el.value);                        
                    }
                });
                // Compte le nombre de caractère restant
                $('#field-message').textAreaCountCaractere();
                
                // Validation étape 1
                $('#btn-suivant-step1').on('click', function (event) {
                    event.preventDefault();
                    Completude.demandeProfesseur.processStep1();                    
                });
                // Validation étape 2
                $('#btn-suivant-step2').on('click', function (event) {
                    event.preventDefault();
                    Completude.demandeProfesseur.processStep2();                    
                });
                               
                                            
                Completude.demandeProfesseur.prefillForm();  
                w.Completude.TagManagerTunnel();                          
                              
            },
                                                       

            /**
             * 
             * @returns Init du formulaire, on se base sur le formulaire demande de tarif
             */
            prefillForm: function () {
                
                let oldValues = Completude.GetStorage("form-demande-tarifs");
                
                if (typeof(oldValues)!=='undefined' && oldValues!==null) {
                    try {
                        let data =  oldValues;

                        // Retrouve la tarif calculé précédement. IL est stocké dans form-demande-tarifs-niveau-1, form-demande-tarifs-niveau-2 ou form-demande-tarifs-niveau-3
                        // selon la classe. On affiche le tarif du dernier
                        let  tarif1=  Completude.GetStorage("form-demande-tarifs-niveau-1");
                        let  tarif2=  Completude.GetStorage("form-demande-tarifs-niveau-2");
                        let  tarif3=  Completude.GetStorage("form-demande-tarifs-niveau-3");
                        let  tarif4=  Completude.GetStorage("form-demande-tarifs-niveau-4");
                        let  tarifNet = null;
                        let  tarifHoraire = null;
                        if (typeof(tarif1)!='undefinded' && tarif1!=null && tarif1.demandeTarifs.IdClasse==data.IdClasse) {
                            tarifNet =  tarif1.demandeTarifs.NetTotal;
                            tarifHoraire = tarif1.demandeTarifs.TarifHoraire;
                        }
                        else if (typeof(tarif2)!='undefinded' && tarif2!=null && tarif2.demandeTarifs.IdClasse==data.IdClasse) {
                            tarifNet =  tarif2.demandeTarifs.NetTotal;
                            tarifHoraire = tarif2.demandeTarifs.TarifHoraire;
                        }
                        else if (typeof(tarif3)!='undefinded' && tarif3!=null && tarif3.demandeTarifs.IdClasse==data.IdClasse) {
                            tarifNet =  tarif3.demandeTarifs.NetTotal;
                            tarifHoraire = tarif3.demandeTarifs.TarifHoraire;
                        }
                        else if (typeof(tarif4)!='undefinded' && tarif4!=null && tarif4.demandeTarifs.IdClasse==data.IdClasse) {
                            tarifNet =  tarif4.demandeTarifs.NetTotal;
                            tarifHoraire = tarif4.demandeTarifs.TarifHoraire;
                        }
                        $("#form-demande-prof #etape1").mapObject({TarifNet : tarifNet, TarifHoraire : tarifHoraire});

                        // Init par défaut du formulaire
                        $('#field-class').val(data.IdClasse).selectric('refresh');                           
                        Completude.demandeProfesseur.updateMatieres(data.IdClasse, data.IdMatiere);
                        $("#field-address").SetLocalisation(data.localisation);                    
                        $('#field-nom').val(data.Nom).focusout();
                        $('#field-phone') .val(data.Telephone).focusout();
                        $('#field-email').val(data.Email).focusout();
                        if (data.Sexe!==undefined) {
                            if (data.Sexe==="1") {                                
                                $("#field-civilite-homme").prop("checked", true);
                            }
                            if (data.Sexe==="2") {                                
                                $("#field-civilite-femme").prop("checked", true);
                            }
                        }                       
                    }
                    catch (e) {
                        console.info('Erreur in form-demande-prof.prefillForm()');
                    }                    
                } else {
                    $("#form-demande-prof #etape1 .locations-message").remove();
                }           
                
            },
            
            /**
             * Validation de l'étape "L'élève"
             * @returns Validation de l'étape 1
             */
            processStep1: function () {
                if (!Completude.demandeProfesseur.$form.validate({group:'step1'})) {
                    return;
                }
                // Passe à l'étape suivante                       
                Completude.demandeProfesseur.steps.next();                           
                w.Completude.TagManager(Completude.demandeProfesseur.gtmPage,'Coordonnees');
                w.Completude.TagManagerTunnel();
                document.querySelector('body').scrollIntoView()              
            },

            /**
             * Validation de l'étape "Je vérifie mes coordonnées"
             */
            processStep2: function () {
                if (!Completude.demandeProfesseur.$form.validate({group:'step2'})) {
                    return;
                }

                var postData = Object.assign({
                    'action': 'wp_demande_prof',
                    'Latitude': window.autocomplete.localisation.lat,
                    'Longitude': window.autocomplete.localisation.lng,
                    'Ville': window.autocomplete.localisation.city,
                    'CodePostal': window.autocomplete.localisation.postalCode,
                    'Adresse': window.autocomplete.localisation.address,                    
                    'Telephone' : $('#field-phone').val(),
                    'Email' : $('#field-email').val(),
                    'AccordEMail' : $('#field-info').prop("checked"),
                    'Nom' : $('#field-nom').val(),                  
                    'NomEleve' : $('#field-nom-eleve').val(),                  
                    'PrenomEleve' : $('#field-prenom-eleve').val(), 
                    'Commentaires' : $('#field-message').val(),
                    'IdClasse' : $('#field-class').val(), 
                   // 'Classe' : el.options[el.selectedIndex].innerHTML, 
                    'IdMatiere' : $('#field-matiere').val(),                                   
                    'Sexe' :  $("[name='civilite']:checked").val(),
                    'SexeEleve' :  $("[name='civilite-eleve']:checked").val()
                  }, Completude.GetGlobalUtmFields());

                
                jQuery("#etape2>div:first-child").loading(
                    jQuery.ajax({
                        url: disko_ajax_object.ajaxurl,                        
                        type    : 'post',
                        data    : postData,
                        dataType: 'json',
                        cache   : false,
                        success : function (response) {
                            
                            if (response.success) {
                                                                                                
                                // Sauvegarde des données du formulaire
                                Completude.SetStorage('form-demande-professeur',   Object.assign(postData,{ 'localisation' : autocomplete.localisation}));                                                            
                                w.Completude.agence = response.data.Agence;
                                w.Completude.UpdateAgence(response.data.Agence.Id);
                                let el =  document.getElementById('field-matiere');
                                let matiere = el.options[el.selectedIndex].innerHTML;
                                matiere =  (Completude.beginsWithVowel(matiere) ? "d'": "de ") + matiere; 
                                $("#demande-prof-success-template").mapObject( Object.assign(response.data,{Matiere : matiere }));
                                                                
                                jQuery('.progress-steps').hide()                                                                                            
                                // Passe à l'étape suivante                       
                                Completude.demandeProfesseur.steps.next();                                
                                w.Completude.TagManager(Completude.demandeProfesseur.gtmPage,'Confirmation');
                                w.Completude.TagManagerTunnel();
                                document.querySelector('body').scrollIntoView()
                            }
                            return false;
                        }
                    }).promise()
                );
                                                                               
            },
            
            /**
             * Mise à jour de la liste des matières
             * @param {id de la classe} IdClasse 
             * @param {id de la matière à selectionner} IdMatiere  (facultatif)
             */
            updateMatieres: function (IdClasse,IdMatiere) {
                Completude.GetMatieres(IdClasse).then(function(response) {
                    if ( true    == response.success) {
                        var matieres = response.data;                        
                        $("#field-matiere").removeAttr('disabled').selectric('refresh');                                                                     
                        $("#field-matiere").find('option').remove().end().append('<option value="" selected></option>')                     
                        jQuery.each(matieres, function (i, matiere) {
                            $("#field-matiere").append(                                                       
                            $('<option>', { 
                                value: matiere.Id,
                                text : matiere.Libelle,                               
                            }))
                        });
                        if (typeof(IdMatiere)!=='undefined' && IdMatiere!==null) {
                            $('#field-matiere option[value="'+ IdMatiere +'"]').prop('selected',true);
                        }
                        // Refresh du composant selectric
                        $('#field-matiere').selectric('refresh');
                    }                         
                });                
            },

        }
    })
})(window);


jQuery(function () {
    if (jQuery("#section-form-demande-prof").length > 0) {
        Completude.demandeProfesseur.init();
    }
});